import React from 'react';
import ReactDOM from 'react-dom';
import OrganizationSearch from '../../src/organization_search/organization_search';
import DevexHighOrderComponent from '../../src/components/react/devex_high_order_component/devex_high_order_component';
import { ORGANIZATIONS_SEARCH_PATH } from '../../src/utilities/devex_paths';

document.addEventListener('DOMContentLoaded', () => {
  const root = document.getElementById('organizationSearch');
  if (root) {
    ReactDOM.render(
      <DevexHighOrderComponent>
        <OrganizationSearch
          isDesktop={JSON.parse(root.dataset.isDesktop)}
          organizationTypes={JSON.parse(root.dataset.organizationTypes)}
          isRecruiter={JSON.parse(root.dataset.isRecruiter) === 'true'}
        />
      </DevexHighOrderComponent>,
      root
    );
  }

  // HACK: If there is a subnav entry called `Top Employers` and if the filter
  // `top_employers_only` is set to `true`, on page load, instead of
  // highlighting `Organizations` subnav item, we want to highlight `Top employers`
  // one. To do so, manually manipulate the CSS classes of the subnavigation menu.
  const forceTopEmployersNavHighlight = () => {
    const subnavigation = document.querySelector('nav.section-subnavigation');
    if (subnavigation) {
      // Locate and determine if Top Employers subnavigation entry exists
      const topEmployersLink = subnavigation.querySelector(
        `a[href="${ORGANIZATIONS_SEARCH_PATH}?filter%5Btop_employers_only%5D=true"]`
      );

      // If link exists and top employers filter is set to true, highlight `Top Employers`
      // subnav item
      if (topEmployersLink) {
        const urlParams = new URLSearchParams(document.location.search);
        if (urlParams.get('filter[top_employers_only]') === 'true') {
          // Remove active class from "Organizations" subnavigation entry
          const organizationsLink = subnavigation.querySelector('a.active');
          if (organizationsLink) {
            organizationsLink.classList.remove('active');
          }

          // Add "active" CSS class to "Top employers" subnavigation entry
          topEmployersLink.classList.add('active');
        }
      }
    }
  };

  forceTopEmployersNavHighlight();
});
